import React from "react";
import SiteSection from "../components/Site/SiteSection";

const SiteSettings = () => {
  return <SiteSection />;
};

export default SiteSettings;
